import { render, staticRenderFns } from "./hy.vue?vue&type=template&id=2dd87f08&scoped=true&"
import script from "./hy.vue?vue&type=script&lang=js&"
export * from "./hy.vue?vue&type=script&lang=js&"
import style0 from "./hy.vue?vue&type=style&index=0&id=2dd87f08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd87f08",
  null
  
)

export default component.exports